import * as Yup from 'yup'

export const managedFundValidationSchema = Yup.object().shape({
  apir: Yup.string().required(),
  quantity: Yup.number().required(),
  price: Yup.number().required(),
  purchaseDate: Yup.date().required(),
  interestPaidCode: Yup.string().required(),
  allocationCode: Yup.string().required(),
  note: Yup.string().nullable(),
  reference: Yup.string().nullable(),
  bankReference: Yup.string().nullable(),
})
